<div
  class="editable"
  *ngIf="!editing && !multiple"
  (click)="edit()"
  (focus)="edit()"
  tabindex="0"
  [ngClass]="{ readonly: readonly }"
  [matTooltip]="showTip"
  [class.locked]="fieldDef.locked"
>
  <div *ngIf="isNestedField; else text">
    <div *ngFor="let item of value; let last = last">
      {{ (item.label | treoFindByKey: 'id':options)?.name || (item.label | treoFindByKey: 'id':options)?.full_name
      }}<span *ngIf="!last">, </span>
    </div>
  </div>

  <ng-template #text>
    {{ (value | treoFindByKey: 'id':options)?.name || (value | treoFindByKey: 'id':options)?.full_name }}
  </ng-template>
</div>
<ng-container *ngIf="editing && !multiple">
  <select
    [(ngModel)]="value"
    (blur)="onBlur()"
    [disabled]="!editing || isDisabled"
    (change)="onSelectionChange()"
    class="dropdown-menu-wrapper"
    tabindex="0"
  >
    <option [value]="">--Select--</option>
    <option *ngIf="userEditable" value="add_new">--Edit--</option>
    <option *ngFor="let option of options" [value]="option.id">
      {{ option.name || option.full_name }}
    </option>
  </select>
</ng-container>

<div
  class="editable"
  *ngIf="!editing && multiple"
  (click)="edit()"
  (focus)="edit()"
  tabindex="0"
  [ngClass]="{ readonly: readonly }"
  [matTooltip]="showTip"
>
  <div *ngIf="isNestedField; else textMulti">
    <div *ngFor="let item of value; let last = last">
      {{ nestedFieldArrayValue(item.label).join() }} <span *ngIf="!last"> | </span>
    </div>
  </div>

  <ng-template #textMulti let-value>
    <ng-container *ngIf="isArray(value); else textSingle">
      {{ value.join() || '' }}
    </ng-container>
  </ng-template>
  <ng-template #textSingle>
    {{ value || '' }}
  </ng-template>
</div>
<ng-container *ngIf="editing && multiple">
  <mat-select
    multiple
    (openedChange)="openedChange($event)"
    (selectionChange)="onSelectionChange()"
    [(ngModel)]="value"
    [disabled]="!editing || isDisabled"
    tabindex="0"
  >
    <mat-option *ngFor="let option of options" [value]="option.id">
      {{ option?.name || option?.full_name }}
    </mat-option>
  </mat-select>
</ng-container>
